import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { SubtasksRoutes } from "../../constants/subtasks/subtasks.constants";
import {
    CorrespondenceResponse,
    SubtaskCorrespondenceEmailModel,
    SubtaskTypeModel,
    AddSubtaskRequest,
    SaveSubtaskTypeResponse,
    EmailInvitationCorrespondenceResponse,
    CorrespondenceReplyResponse,
    SubtaskModel,
    SaveSubtaskTypeRequest,
    SubtaskIdentifierModel
} from "../../models/vetting/vetting.models";
import { CorrespondenceCountsResponse, CorrespondenceItemModel } from "../../models/vessels/vessel.models";

@autoinject
export class SubtasksService {

    constructor(private requestClient: RequestClientService) {
    }

    public reply(guid: string, subtaskCorrespondenceId: number, message: string, submit: boolean, isFromAdmin: boolean, changeStatusToAwaitingResponse: boolean,
        subtaskTypes: number[], emails: SubtaskCorrespondenceEmailModel[], statusSnippet: string, comment: string, ea: string): Promise<CorrespondenceReplyResponse> {
        return this.requestClient.post(`${SubtasksRoutes.Reply}`, {}, {
            guid: guid,
            emails: emails,
            message: message,
            submit: submit,
            subtaskCorrespondenceId: subtaskCorrespondenceId,
            isFromAdmin: isFromAdmin,
            changeStatusToAwaitingResponse: changeStatusToAwaitingResponse,
            subtaskTypes: subtaskTypes,
            comment: comment,
            statusSnippet: statusSnippet,
            ea: ea
        });
    }

    public acceptInvitation(guid: string, subtaskCorrespondenceId: number, emails: SubtaskCorrespondenceEmailModel[]): Promise<EmailInvitationCorrespondenceResponse> {
        return this.requestClient.post(`${SubtasksRoutes.AcceptInvitation}`, {}, {
            guid: guid,
            emails: emails,
            subtaskCorrespondenceId: subtaskCorrespondenceId
        });
    }

    public getCorrespondence(guid: string): Promise<CorrespondenceResponse> {
        return this.requestClient.get(`${SubtasksRoutes.GetCorrespondence}/${guid}`, {});
    }

    public getSubtaskType(subtaskTypeId: number): Promise<SubtaskTypeModel> {
        return this.requestClient.get(`${SubtasksRoutes.GetSubtaskType}/${subtaskTypeId}`, {});
    }

    public getSubtask(subtaskId: number): Promise<SubtaskModel> {
        return this.requestClient.get(`${SubtasksRoutes.GetSubtask}/${subtaskId}`, {});
    }

    public getSubtaskByVesselMou(vesselId: number, mou: number): Promise<SubtaskIdentifierModel> {
        return this.requestClient.get(`${SubtasksRoutes.GetSubtaskByVesselMou}/${vesselId}/${mou}`, {});
    }

    public saveSubtaskType(subtaskType: SaveSubtaskTypeRequest): Promise<SaveSubtaskTypeResponse> {
        return this.requestClient.post(SubtasksRoutes.SaveSubtaskType, {}, subtaskType);
    }

    public deleteSubtaksTypes(subtaskTypeIds: number[]): Promise<void> {
        return this.requestClient.post(SubtasksRoutes.DeleteSubtaskTypes, {}, subtaskTypeIds);
    }

    public setAsReviewed(subtaskId: number): Promise<void> {
        return this.requestClient.post(`${SubtasksRoutes.SetAsReviewed}/${subtaskId}`, {}, {});
    }

    public setVetTaskAsReviewed(vetTaskId: number): Promise<void> {
        return this.requestClient.post(`${SubtasksRoutes.SetVetTaskAsReviewed}/${vetTaskId}`, {}, {});
    }

    public closeRFI(subtaskId: number, sendEmail: boolean = false): Promise<void> {
        return this.requestClient.post(`${SubtasksRoutes.SetAsClosed}/${subtaskId}`, { sendEmail: sendEmail }, {});
    }

    public addSubtask(request: AddSubtaskRequest): Promise<number> {
        return this.requestClient.postFormData(`${SubtasksRoutes.AddSubtask}`, request);
    }

    public getCorrespondenceForEntity(entityId: number, entityTypeId: number, filter: string = null, rfiTypeIds: number[] = null): Promise<CorrespondenceItemModel[]> {
        return this.requestClient.get(`${SubtasksRoutes.GetCorrespondenceForEntity}/${entityId}/${entityTypeId}`, { filter: filter, rfiTypeIds: rfiTypeIds });
    }

    public getCorrespondenceCountsForEntity(entityId: number, entityTypeId: number): Promise<CorrespondenceCountsResponse> {
        return this.requestClient.get(`${SubtasksRoutes.GetCorrespondenceCountsForEntity}/${entityId}/${entityTypeId}`, {});
    }

    public addAttachmentToEntityDocuments(path: string, filename: string, entityId: number, entityTypeId: number, attachmentTypeId: number): Promise<void> {
        return this.requestClient.post(SubtasksRoutes.AddAttachmentToEntityDocuments, {}, { filePath: path, fileName: filename, entityId: entityId, entityTypeId: entityTypeId, attachmentTypeId: attachmentTypeId });
    }
}
